/**
 * ToolRail — the detail page's right rail: where the tool comes from and the templates that use it (entity-management
 * §1.4). Demo page: /profile (side cards).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Bot } from 'lucide-react';
import { Card, ItemList } from '../../../components/ui/index.js';
import type { Tool } from '../../../generated/api/types.gen.js';
import { FactList, FactRow } from '../template-detail/detail-parts.js';

export const ToolRail: React.FC<{ tool: Tool }> = ({ tool }) => (
  <>
    <Card title="Runtime source">
      <FactList>
        <FactRow label="Source" value={tool.sourceLabel} />
        <FactRow label="Reference" value={tool.sourceReference ?? 'None'} />
        <FactRow label="Supported models" value={tool.supportedModels.length} />
      </FactList>
    </Card>
    <Card title={`Used by templates (${tool.templates.length})`}>
      {tool.templates.length === 0 ? (
        <p className="text-sm text-muted">No template uses this tool yet.</p>
      ) : (
        <ItemList
          aria-label="Templates that use this tool"
          items={tool.templates.map((template) => ({
            id: String(template.id),
            leading: <Bot size={16} className="text-muted" aria-hidden="true" />,
            title: (
              <Link to={`/agents/templates/${template.slug}`} className="hover:text-accent-text">
                {template.name}
              </Link>
            ),
          }))}
        />
      )}
    </Card>
  </>
);
